"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { AlertDialog, Flex } from "@radix-ui/themes";
import { AlertDialogContent, DestructiveButton, SecondaryButton, } from "./elements";
import { getSessionsQueryKey, useRevokeAllSessions } from "../api";
import { useQueryClient } from "@tanstack/react-query";
import { SaveButton } from "./save-button";
export function LogoutAllSessionsDialog({ open, onOpenChange, children, currentSessionId, ...props }) {
    const client = useQueryClient();
    const revokeAllSessions = useRevokeAllSessions();
    const onSubmitForm = () => {
        revokeAllSessions.mutate({ data: { currentSessionId } });
    };
    const handleDone = React.useCallback(() => {
        onOpenChange?.(false);
        client.invalidateQueries({
            queryKey: getSessionsQueryKey(),
        });
    }, [client, onOpenChange]);
    return (_jsx(AlertDialog.Root, { open: open, onOpenChange: onOpenChange, ...props, children: _jsxs(AlertDialogContent, { maxWidth: "480px", children: [_jsx(AlertDialog.Title, { children: "Sign out of all other devices?" }), _jsx(AlertDialog.Description, { children: "You will be logged out of all other active sessions on other devices, except this one." }), _jsx(Flex, { gap: "3", justify: "end", mt: "5", asChild: true, children: _jsxs("form", { onSubmit: (event) => {
                            event.preventDefault();
                            onSubmitForm();
                        }, children: [_jsx(AlertDialog.Cancel, { children: _jsx(SecondaryButton, { disabled: revokeAllSessions.isPending || revokeAllSessions.isSuccess, children: "Cancel" }) }), _jsx(SaveButton, { asChild: true, loading: revokeAllSessions.isPending, done: revokeAllSessions.isSuccess, onDone: handleDone, children: _jsx(DestructiveButton, { type: "submit", children: "Sign out" }) })] }) })] }) }));
}
//# sourceMappingURL=logout-all-sessions-dialog.js.map